import styled from "styled-components";

export const ResultsPanel = styled.section`
  grid-area: results;
  display: flex;
  flex-direction: column;
  padding-right: 40px;
  padding-left: 20px;
  overflow-y: auto;
`;
